
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1b2a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1b2a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("gPMXL", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4HC5g").then(()=>parcelRequire("28NiE"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("1QDgf", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aym8Q").then(()=>parcelRequire("aOnO8"));

});

var $97123798cbbfe7f8$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["lXmvT","index.cd539a39.js","4HC5g","../../elk-api.d9110875.js","dpcWc","../../elk-worker.min.414ac802.js","aym8Q","../../elk.bundled.eaac972f.js","h1PFW","../../index.8df30ad0.js"]'));

const $63cf74f2526d32c7$var$affinityKey = (from, to)=>`${from}\u2192${to}`;
/** Where each edge lives, and which two children of that container it joins. */ function $63cf74f2526d32c7$var$siblingLinks(state, edgeId) {
    const groupIds = new Set(state.groups.map((g)=>g.id));
    const parentOf = new Map();
    for (const group of state.groups)parentOf.set(group.id, group.parent !== undefined && groupIds.has(group.parent) ? group.parent : undefined);
    for (const node of state.nodes)parentOf.set(node.id, node.group !== undefined && groupIds.has(node.group) ? node.group : undefined);
    const chain = (id)=>{
        const path = [
            id
        ];
        for(let current = parentOf.get(id); current !== undefined; current = parentOf.get(current))path.unshift(current);
        path.unshift(undefined);
        return path;
    };
    return state.edges.map((edge)=>{
        const a = chain(edge.from);
        const b = chain(edge.to);
        let depth = 0;
        while(depth + 1 < Math.min(a.length, b.length) && a[depth + 1] === b[depth + 1])depth++;
        // Either end may be a group; one containing the other has no route to draw.
        if (depth + 1 >= Math.min(a.length, b.length)) throw new Error(`edge "${edgeId(edge)}" joins a group to something inside it`);
        return {
            edge: edge,
            id: edgeId(edge),
            container: a[depth],
            from: a[depth + 1],
            to: b[depth + 1]
        };
    });
}
function $63cf74f2526d32c7$export$ddd3b0171c32bcf0(states, edgeId) {
    const seen = new Map();
    for (const state of states)for (const link of $63cf74f2526d32c7$var$siblingLinks(state, edgeId)){
        if (link.from === link.to) continue;
        const key = $63cf74f2526d32c7$var$affinityKey(link.from, link.to);
        const ids = seen.get(key) ?? new Set();
        ids.add(link.id);
        seen.set(key, ids);
    }
    return new Map([
        ...seen
    ].map(([key, ids])=>[
            key,
            ids.size
        ]));
}
/** Clear space between two cards in the same layer. */ const $63cf74f2526d32c7$var$NODE_GAP = 30;
/** Clear space between layers; routed edges run in this gap. */ const $63cf74f2526d32c7$var$LAYER_GAP = 56;
/** Spacing between parallel edge runs, and between a run and a card. */ const $63cf74f2526d32c7$var$EDGE_GAP = 14;
const $63cf74f2526d32c7$var$EDGE_NODE_GAP = 16;
const $63cf74f2526d32c7$var$GROUP_PADDING = 18;
/** Extra room under a group's top border, where its legend plate sits. */ const $63cf74f2526d32c7$var$GROUP_TITLE_PAD = 12;
const $63cf74f2526d32c7$var$ROOT_OPTIONS = {
    "elk.algorithm": "layered",
    "elk.hierarchyHandling": "INCLUDE_CHILDREN",
    "elk.edgeRouting": "ORTHOGONAL",
    "elk.randomSeed": "7",
    "elk.json.edgeCoords": "ROOT",
    "elk.json.shapeCoords": "ROOT",
    "elk.padding": "[top=20,left=20,bottom=20,right=20]",
    "elk.spacing.nodeNode": String($63cf74f2526d32c7$var$NODE_GAP),
    "elk.layered.spacing.nodeNodeBetweenLayers": String($63cf74f2526d32c7$var$LAYER_GAP),
    "elk.spacing.edgeEdge": String($63cf74f2526d32c7$var$EDGE_GAP),
    "elk.spacing.edgeNode": String($63cf74f2526d32c7$var$EDGE_NODE_GAP),
    "elk.layered.spacing.edgeEdgeBetweenLayers": String($63cf74f2526d32c7$var$EDGE_GAP),
    "elk.layered.spacing.edgeNodeBetweenLayers": String($63cf74f2526d32c7$var$EDGE_NODE_GAP),
    "elk.spacing.edgeLabel": "4",
    "elk.spacing.componentComponent": String($63cf74f2526d32c7$var$LAYER_GAP),
    "elk.edgeLabels.placement": "CENTER",
    "elk.layered.edgeLabels.sideSelection": "SMART_DOWN",
    // The order objects were added in is the order they are drawn in: a new
    // node slots in beside the ones it arrived after instead of reshuffling.
    "elk.layered.considerModelOrder.strategy": "NODES_AND_EDGES",
    "elk.layered.crossingMinimization.forceNodeModelOrder": "false",
    // Longest-path layering puts every source on the top layer, so sibling
    // groups fed from the same place sit side by side instead of stacking.
    "elk.layered.layering.strategy": "LONGEST_PATH",
    "elk.layered.thoroughness": "30",
    "elk.layered.nodePlacement.strategy": "NETWORK_SIMPLEX",
    "elk.layered.nodePlacement.favorStraightEdges": "true",
    "elk.layered.unnecessaryBendpoints": "false",
    // Merging edges into shared trunks reads as a bundle but stacks dashed,
    // solid and flow lines on top of each other; packed lanes stay legible.
    "elk.layered.mergeEdges": "false",
    "elk.separateConnectedComponents": "false"
};
const $63cf74f2526d32c7$var$GROUP_OPTIONS = {
    "elk.padding": `[top=${$63cf74f2526d32c7$var$GROUP_PADDING + $63cf74f2526d32c7$var$GROUP_TITLE_PAD},left=${$63cf74f2526d32c7$var$GROUP_PADDING},bottom=${$63cf74f2526d32c7$var$GROUP_PADDING},right=${$63cf74f2526d32c7$var$GROUP_PADDING}]`
};
function $63cf74f2526d32c7$export$bccc106c6d23c5a6(input) {
    const { state: state, direction: direction, cards: cards, edgeLabels: edgeLabels, groupLabels: groupLabels, edgeId: edgeId, affinity: affinity, legendRoom: legendRoom } = input;
    const root = {
        id: "__root",
        layoutOptions: {
            ...$63cf74f2526d32c7$var$ROOT_OPTIONS,
            "elk.direction": direction
        },
        children: [],
        edges: []
    };
    const containers = new Map([
        [
            undefined,
            root
        ]
    ]);
    // Groups are created before nodes so members can be attached to them; a
    // group whose parent comes later in the list is attached once it exists.
    const pending = [
        ...state.groups
    ];
    for (const group of pending)containers.set(group.id, {
        id: group.id,
        children: [],
        edges: []
    });
    for (const group of pending){
        const elk = containers.get(group.id);
        const label = groupLabels.get(group.id);
        // The legend sits on the top border, so the panel must be at least that
        // wide; when edges crossed it, the contents move clear of it altogether.
        const left = $63cf74f2526d32c7$var$GROUP_PADDING + (label && legendRoom?.has(group.id) ? label.width : 0);
        elk.layoutOptions = {
            ...$63cf74f2526d32c7$var$GROUP_OPTIONS,
            "elk.padding": `[top=${$63cf74f2526d32c7$var$GROUP_PADDING + $63cf74f2526d32c7$var$GROUP_TITLE_PAD},left=${left},bottom=${$63cf74f2526d32c7$var$GROUP_PADDING},right=${$63cf74f2526d32c7$var$GROUP_PADDING}]`,
            "elk.nodeSize.constraints": "[MINIMUM_SIZE]",
            "elk.nodeSize.minimum": `(${label ? label.width + 40 : 0}, 0)`
        };
        const parent = group.parent !== undefined && containers.has(group.parent) ? group.parent : undefined;
        containers.get(parent).children.push(elk);
    }
    for (const node of state.nodes){
        const size = cards.get(node.id);
        if (!size) throw new Error(`no card size for node "${node.id}"`);
        const parent = node.group !== undefined && containers.has(node.group) ? node.group : undefined;
        containers.get(parent).children.push({
            id: node.id,
            width: size.width,
            height: size.height
        });
    }
    // ELK wants each edge in the lowest container that holds both ends.
    const placed = $63cf74f2526d32c7$var$siblingLinks(state, edgeId);
    // An edge that runs backwards between two sibling groups has to leave the
    // first group through its far side and loop around everything in between.
    // Ordering each container's children to minimise backward edges, and laying
    // the remaining ones out reversed, keeps every route short and forward.
    const reversed = new Set();
    for (const [containerId, container] of containers){
        const siblings = container.children.map((child)=>child.id);
        const links = placed.filter((p)=>p.container === containerId && p.from !== p.to);
        const weight = (from, to)=>affinity?.get($63cf74f2526d32c7$var$affinityKey(from, to)) ?? links.filter((l)=>l.from === from && l.to === to).length;
        const rank = new Map($63cf74f2526d32c7$var$feedbackOrder(siblings, weight).map((id, index)=>[
                id,
                index
            ]));
        container.children.sort((a, b)=>rank.get(a.id) - rank.get(b.id));
        for (const link of links)if (rank.get(link.from) > rank.get(link.to)) reversed.add(link.id);
    }
    for (const { edge: edge, id: id, container: container } of placed){
        const flip = reversed.has(id);
        const elkEdge = {
            id: id,
            sources: [
                flip ? edge.to : edge.from
            ],
            targets: [
                flip ? edge.from : edge.to
            ]
        };
        const label = edgeLabels.get(id);
        if (label) elkEdge.labels = [
            {
                id: `${id}::label`,
                text: edge.label ?? "",
                width: label.width,
                height: label.height
            }
        ];
        containers.get(container).edges.push(elkEdge);
    }
    return {
        graph: root,
        reversed: reversed
    };
}
/**
 * Greedy feedback-arc-set ordering (Eades, Lin & Smyth): sinks go last,
 * sources first, otherwise the node with the most surplus outflow. Ties keep
 * model order, so the result is deterministic and stable as edges are added.
 */ function $63cf74f2526d32c7$var$feedbackOrder(ids, weight) {
    const remaining = new Set(ids);
    const degree = (id, out)=>{
        let total = 0;
        for (const other of remaining)if (other !== id) total += out ? weight(id, other) : weight(other, id);
        return total;
    };
    const head = [];
    const tail = [];
    while(remaining.size > 0){
        let changed = true;
        while(changed){
            changed = false;
            for (const id of ids){
                if (!remaining.has(id)) continue;
                if (degree(id, true) === 0 && degree(id, false) > 0) {
                    tail.unshift(id);
                    remaining.delete(id);
                    changed = true;
                } else if (degree(id, false) === 0 && degree(id, true) > 0) {
                    head.push(id);
                    remaining.delete(id);
                    changed = true;
                }
            }
        }
        if (remaining.size === 0) break;
        // Unconnected children keep their model order; everyone else is on a cycle.
        let best = null;
        let bestScore = -Infinity;
        for (const id of ids){
            if (!remaining.has(id)) continue;
            const score = degree(id, true) - degree(id, false);
            if (score > bestScore) {
                best = id;
                bestScore = score;
            }
        }
        head.push(best);
        remaining.delete(best);
    }
    return [
        ...head,
        ...tail
    ];
}
function $63cf74f2526d32c7$export$a831ad147daba410(root, groupIds, reversed) {
    const nodes = new Map();
    const groups = new Map();
    const edges = new Map();
    const visit = (node)=>{
        for (const child of node.children ?? []){
            const rect = {
                x: child.x ?? 0,
                y: child.y ?? 0,
                width: child.width ?? 0,
                height: child.height ?? 0
            };
            if (groupIds.has(child.id)) groups.set(child.id, rect);
            else nodes.set(child.id, {
                x: rect.x + rect.width / 2,
                y: rect.y + rect.height / 2
            });
            visit(child);
        }
        for (const edge of node.edges ?? []){
            const points = [];
            for (const section of $63cf74f2526d32c7$var$orderSections(edge.sections ?? [])){
                const run = [
                    section.startPoint,
                    ...section.bendPoints ?? [],
                    section.endPoint
                ];
                for (const p of run){
                    const last = points[points.length - 1];
                    if (!last || Math.abs(last.x - p.x) > 0.01 || Math.abs(last.y - p.y) > 0.01) points.push({
                        x: p.x,
                        y: p.y
                    });
                }
            }
            $63cf74f2526d32c7$var$squareUp(points);
            if (reversed.has(edge.id)) points.reverse();
            const label = edge.labels?.[0];
            edges.set(edge.id, {
                points: points,
                label: label ? {
                    x: label.x ?? 0,
                    y: label.y ?? 0,
                    width: label.width ?? 0,
                    height: label.height ?? 0
                } : null
            });
        }
    };
    visit(root);
    return {
        nodes: nodes,
        groups: groups,
        edges: edges,
        width: root.width ?? 0,
        height: root.height ?? 0
    };
}
/** Sections of a split edge, in path order (ELK does not promise array order). */ function $63cf74f2526d32c7$var$orderSections(sections) {
    if (sections.length < 2) return sections;
    const byId = new Map(sections.map((section)=>[
            section.id,
            section
        ]));
    let current = sections.find((section)=>!section.incomingSections?.some((id)=>byId.has(id))) ?? sections[0];
    const ordered = [];
    const seen = new Set();
    while(current && !seen.has(current.id)){
        ordered.push(current);
        seen.add(current.id);
        current = byId.get(current.outgoingSections?.find((id)=>byId.has(id)) ?? "");
    }
    // Anything not reachable (should not happen) keeps its place after the chain.
    return [
        ...ordered,
        ...sections.filter((section)=>!seen.has(section.id))
    ];
}
/**
 * ELK can leave sub-pixel jogs where a route crosses a group border. Snapping
 * them, walking back from the target, keeps every segment horizontal or
 * vertical; a point on a card border only slides along that border.
 */ function $63cf74f2526d32c7$var$squareUp(points) {
    for(let i = points.length - 1; i > 0; i--){
        const a = points[i - 1];
        const b = points[i];
        const dx = Math.abs(a.x - b.x);
        const dy = Math.abs(a.y - b.y);
        if (dx > 0 && dx < 1 && dy >= 1) a.x = b.x;
        else if (dy > 0 && dy < 1 && dx >= 1) a.y = b.y;
    }
}


const $d6891e08b5dc252b$export$f07f6a1752e5a26e = 15;
const $d6891e08b5dc252b$export$cc6dcdfdb99a166a = 11;
const $d6891e08b5dc252b$export$8a610d856257adef = "'Geist Pixel', 'Geist Mono', ui-monospace, monospace";
/** Fallback advance width, as a fraction of font size, when nothing can measure text. */ const $d6891e08b5dc252b$var$CHAR_ADVANCE = 0.68;
const $d6891e08b5dc252b$var$SIGIL_WIDTH = 20;
const $d6891e08b5dc252b$var$PAD_X = 11;
const $d6891e08b5dc252b$var$CARD_HEIGHT = 30;
const $d6891e08b5dc252b$var$CARD_HEIGHT_TWO_LINE = 44;
const $d6891e08b5dc252b$var$CHAMFER = 6;
const $d6891e08b5dc252b$var$ROUND = 4;
/** ASCII sigils read as terminal markers rather than decoration. */ const $d6891e08b5dc252b$var$KIND_SIGILS = {
    human: "@",
    agent: "*",
    service: "#",
    tool: ">",
    repo: "/",
    skill: "+",
    model: "%",
    chat: "?",
    machine: "="
};
function $d6891e08b5dc252b$export$7da6558600d0a5d8(kind) {
    return kind && $d6891e08b5dc252b$var$KIND_SIGILS[kind] || "\xb7";
}
const $d6891e08b5dc252b$export$d53f15ae72d7df7 = (text, size)=>text.length * size * $d6891e08b5dc252b$var$CHAR_ADVANCE;
function $d6891e08b5dc252b$export$2d6e8db79a5f55f() {
    const context = typeof document === "undefined" ? null : document.createElement("canvas").getContext("2d");
    if (!context) return $d6891e08b5dc252b$export$d53f15ae72d7df7;
    const cache = new Map();
    return (text, size)=>{
        const key = `${size}:${text}`;
        const cached = cache.get(key);
        if (cached !== undefined) return cached;
        context.font = `500 ${size}px ${$d6891e08b5dc252b$export$8a610d856257adef}`;
        const width = context.measureText(text).width;
        cache.set(key, width);
        return width;
    };
}
function $d6891e08b5dc252b$export$a86b57470971f86f(label, sublabel, measure = $d6891e08b5dc252b$export$d53f15ae72d7df7) {
    const width = Math.max(measure(label, $d6891e08b5dc252b$export$f07f6a1752e5a26e), measure(sublabel, $d6891e08b5dc252b$export$cc6dcdfdb99a166a));
    return {
        width: Math.max(72, Math.ceil(width + $d6891e08b5dc252b$var$SIGIL_WIDTH + $d6891e08b5dc252b$var$PAD_X * 2)),
        height: sublabel ? $d6891e08b5dc252b$var$CARD_HEIGHT_TWO_LINE : $d6891e08b5dc252b$var$CARD_HEIGHT
    };
}
function $d6891e08b5dc252b$export$6919871dc0d016c5(width) {
    return -width / 2 + $d6891e08b5dc252b$var$PAD_X + $d6891e08b5dc252b$var$SIGIL_WIDTH;
}
function $d6891e08b5dc252b$export$31cab2e20805d3be(width) {
    return -width / 2 + $d6891e08b5dc252b$var$PAD_X;
}
const $d6891e08b5dc252b$var$CORNERS = {
    rect: "square",
    hex: "chamfer",
    diamond: "chamfer",
    pill: "round",
    circle: "round"
};
function $d6891e08b5dc252b$export$6755aabc83e985ab(shape, width, height) {
    const w = width / 2;
    const h = height / 2;
    const corner = $d6891e08b5dc252b$var$CORNERS[shape];
    if (corner === "square") return `M${-w},${-h}H${w}V${h}H${-w}Z`;
    if (corner === "chamfer") {
        const c = Math.min($d6891e08b5dc252b$var$CHAMFER, w, h);
        return [
            `M${-w + c},${-h}`,
            `H${w - c}`,
            `L${w},${-h + c}`,
            `V${h - c}`,
            `L${w - c},${h}`,
            `H${-w + c}`,
            `L${-w},${h - c}`,
            `V${-h + c}`,
            "Z"
        ].join("");
    }
    const r = Math.min($d6891e08b5dc252b$var$ROUND, w, h);
    return [
        `M${-w + r},${-h}`,
        `H${w - r}`,
        `A${r},${r} 0 0 1 ${w},${-h + r}`,
        `V${h - r}`,
        `A${r},${r} 0 0 1 ${w - r},${h}`,
        `H${-w + r}`,
        `A${r},${r} 0 0 1 ${-w},${h - r}`,
        `V${-h + r}`,
        `A${r},${r} 0 0 1 ${-w + r},${-h}`,
        "Z"
    ].join("");
}
function $d6891e08b5dc252b$export$9a54b2f78816633(width, height, theta) {
    const dx = Math.cos(theta);
    const dy = Math.sin(theta);
    const w = width / 2;
    const h = height / 2;
    const tx = Math.abs(dx) < 1e-6 ? Infinity : w / Math.abs(dx);
    const ty = Math.abs(dy) < 1e-6 ? Infinity : h / Math.abs(dy);
    return Math.min(tx, ty);
}


const $8c2a8c8b99afbccb$export$a8b6f19ec1c8d472 = (edge)=>edge.id ?? `${edge.from}->${edge.to}`;
const $8c2a8c8b99afbccb$var$emptyState = ()=>({
        nodes: [],
        edges: [],
        groups: []
    });
/** Assigns patch fields onto target; `null` clears the field. */ function $8c2a8c8b99afbccb$var$applyPatch(target, patch) {
    for (const key of Object.keys(patch)){
        const value = patch[key];
        if (value === null) delete target[key];
        else if (value !== undefined) target[key] = value;
    }
}
const $8c2a8c8b99afbccb$var$cloneState = (state)=>({
        nodes: state.nodes.map((node)=>({
                ...node
            })),
        edges: state.edges.map((edge)=>({
                ...edge
            })),
        groups: state.groups.map((group)=>({
                ...group
            }))
    });
class $8c2a8c8b99afbccb$var$StoryError extends Error {
    constructor(stepIndex, message){
        super(`graph story step ${stepIndex}: ${message}`);
        this.name = "StoryError";
    }
}
function $8c2a8c8b99afbccb$var$applyOp(state, op, stepIndex) {
    const fail = (message)=>{
        throw new $8c2a8c8b99afbccb$var$StoryError(stepIndex, message);
    };
    const findNode = (id)=>state.nodes.find((n)=>n.id === id) ?? fail(`unknown node "${id}"`);
    const findGroup = (id)=>state.groups.find((g)=>g.id === id) ?? fail(`unknown group "${id}"`);
    const findEdge = (id)=>state.edges.find((e)=>$8c2a8c8b99afbccb$export$a8b6f19ec1c8d472(e) === id) ?? fail(`unknown edge "${id}"`);
    const findEnd = (id)=>{
        if (!state.nodes.some((n)=>n.id === id) && !state.groups.some((g)=>g.id === id)) fail(`unknown node or group "${id}"`);
    };
    switch(op.op){
        case "add":
            if ("node" in op) {
                if (state.nodes.some((n)=>n.id === op.node.id)) fail(`duplicate node "${op.node.id}"`);
                if (op.node.group !== undefined) findGroup(op.node.group);
                state.nodes.push({
                    ...op.node
                });
            } else if ("edge" in op) {
                findEnd(op.edge.from);
                findEnd(op.edge.to);
                const id = $8c2a8c8b99afbccb$export$a8b6f19ec1c8d472(op.edge);
                if (state.edges.some((e)=>$8c2a8c8b99afbccb$export$a8b6f19ec1c8d472(e) === id)) fail(`duplicate edge "${id}"`);
                state.edges.push({
                    ...op.edge
                });
            } else {
                if (state.groups.some((g)=>g.id === op.group.id)) fail(`duplicate group "${op.group.id}"`);
                if (op.group.parent !== undefined) findGroup(op.group.parent);
                state.groups.push({
                    ...op.group
                });
            }
            return;
        case "remove":
            if ("node" in op) {
                findNode(op.node);
                state.nodes = state.nodes.filter((n)=>n.id !== op.node);
                state.edges = state.edges.filter((e)=>e.from !== op.node && e.to !== op.node);
            } else if ("edge" in op) {
                findEdge(op.edge);
                state.edges = state.edges.filter((e)=>$8c2a8c8b99afbccb$export$a8b6f19ec1c8d472(e) !== op.edge);
            } else {
                const group = findGroup(op.group);
                // Members and child groups fall back to the removed group's parent.
                for (const node of state.nodes)if (node.group === group.id) node.group = group.parent;
                for (const child of state.groups)if (child.parent === group.id) child.parent = group.parent;
                state.groups = state.groups.filter((g)=>g.id !== group.id);
                state.edges = state.edges.filter((e)=>e.from !== group.id && e.to !== group.id);
            }
            return;
        case "set":
            if ("node" in op) {
                const { op: _op, node: id, ...patch } = op;
                if (patch.group !== undefined && patch.group !== null) findGroup(patch.group);
                $8c2a8c8b99afbccb$var$applyPatch(findNode(id), patch);
            } else if ("edge" in op) {
                const { op: _op, edge: id, ...patch } = op;
                $8c2a8c8b99afbccb$var$applyPatch(findEdge(id), patch);
            } else {
                const { op: _op, group: id, ...patch } = op;
                if (patch.parent !== undefined && patch.parent !== null) findGroup(patch.parent);
                $8c2a8c8b99afbccb$var$applyPatch(findGroup(id), patch);
            }
            return;
        case "move":
            if ("node" in op) {
                const node = findNode(op.node);
                if (op.group === null) delete node.group;
                else {
                    findGroup(op.group);
                    node.group = op.group;
                }
            } else {
                const group = findGroup(op.group);
                if (op.parent === null) delete group.parent;
                else {
                    if (op.parent === group.id) fail(`group "${group.id}" cannot be its own parent`);
                    findGroup(op.parent);
                    group.parent = op.parent;
                }
            }
            return;
    }
}
function $8c2a8c8b99afbccb$var$validateState(state, stepIndex) {
    const nodeIds = new Set();
    const groupIds = new Set(state.groups.map((g)=>g.id));
    for (const node of state.nodes){
        if (nodeIds.has(node.id)) throw new $8c2a8c8b99afbccb$var$StoryError(stepIndex, `duplicate node "${node.id}"`);
        nodeIds.add(node.id);
        if (node.group !== undefined && !groupIds.has(node.group)) throw new $8c2a8c8b99afbccb$var$StoryError(stepIndex, `node "${node.id}" references unknown group "${node.group}"`);
    }
    for (const group of state.groups){
        // Walk up the parent chain to catch cycles and dangling parents.
        const seen = new Set([
            group.id
        ]);
        let parent = group.parent;
        while(parent !== undefined){
            if (!groupIds.has(parent)) throw new $8c2a8c8b99afbccb$var$StoryError(stepIndex, `group "${group.id}" references unknown parent "${parent}"`);
            if (seen.has(parent)) throw new $8c2a8c8b99afbccb$var$StoryError(stepIndex, `group "${group.id}" has a cyclic parent chain`);
            seen.add(parent);
            parent = state.groups.find((g)=>g.id === parent)?.parent;
        }
    }
    const edgeIds = new Set();
    for (const edge of state.edges){
        const id = $8c2a8c8b99afbccb$export$a8b6f19ec1c8d472(edge);
        if (edgeIds.has(id)) throw new $8c2a8c8b99afbccb$var$StoryError(stepIndex, `duplicate edge "${id}"`);
        edgeIds.add(id);
        const known = (end)=>nodeIds.has(end) || groupIds.has(end);
        if (!known(edge.from) || !known(edge.to)) throw new $8c2a8c8b99afbccb$var$StoryError(stepIndex, `edge "${id}" references an unknown node or group`);
        if ($8c2a8c8b99afbccb$var$encloses(state, edge.from, edge.to) || $8c2a8c8b99afbccb$var$encloses(state, edge.to, edge.from)) throw new $8c2a8c8b99afbccb$var$StoryError(stepIndex, `edge "${id}" joins a group to something inside it`);
    }
}
/** True when `outer` is a group that contains `inner`, directly or through nested groups. */ function $8c2a8c8b99afbccb$var$encloses(state, outer, inner) {
    const parentOf = (id)=>state.nodes.find((n)=>n.id === id)?.group ?? state.groups.find((g)=>g.id === id)?.parent;
    for(let current = parentOf(inner); current !== undefined; current = parentOf(current)){
        if (current === outer) return true;
    }
    return false;
}
/** Collects the ids an op touches (removals excluded: they are gone by the time the step renders). */ function $8c2a8c8b99afbccb$var$touchedBy(op, state, focus) {
    const edgeEnds = (edge)=>{
        for (const end of [
            edge.from,
            edge.to
        ])(state.groups.some((g)=>g.id === end) ? focus.panels : focus.nodes).add(end);
        focus.edges.add($8c2a8c8b99afbccb$export$a8b6f19ec1c8d472(edge));
    };
    switch(op.op){
        case "add":
            if ("node" in op) {
                focus.nodes.add(op.node.id);
                focus.core.add(op.node.id);
            } else if ("edge" in op) edgeEnds(op.edge);
            else focus.groups.add(op.group.id);
            return;
        case "set":
            if ("node" in op) {
                focus.nodes.add(op.node);
                focus.core.add(op.node);
            } else if ("edge" in op) {
                const edge = state.edges.find((e)=>$8c2a8c8b99afbccb$export$a8b6f19ec1c8d472(e) === op.edge);
                if (edge) edgeEnds(edge);
            } else focus.groups.add(op.group);
            return;
        case "move":
            if ("node" in op) {
                focus.nodes.add(op.node);
                focus.core.add(op.node);
                if (op.group) focus.groups.add(op.group);
            } else focus.groups.add(op.group);
            return;
        case "remove":
            return;
    }
}
function $8c2a8c8b99afbccb$var$resolveFocus(step, state) {
    const focus = {
        all: false,
        nodes: new Set(),
        groups: new Set(),
        panels: new Set(),
        core: new Set(),
        edges: new Set()
    };
    if (step.focus === "all" || step.state && !step.focus) {
        // Still record what changed so narrow screens have something to frame.
        focus.all = true;
        for (const op of step.ops ?? [])$8c2a8c8b99afbccb$var$touchedBy(op, state, focus);
        if (focus.nodes.size === 0 && focus.groups.size === 0) for (const n of state.nodes)focus.nodes.add(n.id);
        return focus;
    }
    if (Array.isArray(step.focus)) {
        const groupIds = new Set(state.groups.map((g)=>g.id));
        for (const id of step.focus)if (groupIds.has(id)) focus.groups.add(id);
        else {
            focus.nodes.add(id);
            focus.core.add(id);
        }
        return focus;
    }
    for (const op of step.ops ?? [])$8c2a8c8b99afbccb$var$touchedBy(op, state, focus);
    // Drop ids that no longer exist after this step's ops.
    const nodeIds = new Set(state.nodes.map((n)=>n.id));
    const groupIds = new Set(state.groups.map((g)=>g.id));
    const edgeIds = new Set(state.edges.map((e)=>$8c2a8c8b99afbccb$export$a8b6f19ec1c8d472(e)));
    for (const id of focus.nodes)if (!nodeIds.has(id)) focus.nodes.delete(id);
    for (const id of focus.core)if (!nodeIds.has(id)) focus.core.delete(id);
    for (const id of focus.groups)if (!groupIds.has(id)) focus.groups.delete(id);
    for (const id of focus.panels)if (!groupIds.has(id)) focus.panels.delete(id);
    for (const id of focus.edges)if (!edgeIds.has(id)) focus.edges.delete(id);
    if (focus.nodes.size === 0 && focus.groups.size === 0) focus.all = true;
    return focus;
}
function $8c2a8c8b99afbccb$export$7571004462e76c36(spec) {
    if (!Array.isArray(spec.steps) || spec.steps.length === 0) throw new Error("graph story needs at least one step");
    const resolved = [];
    let previous = $8c2a8c8b99afbccb$var$emptyState();
    spec.steps.forEach((step, index)=>{
        const state = $8c2a8c8b99afbccb$var$cloneState(step.state ?? previous);
        for (const op of step.ops ?? [])$8c2a8c8b99afbccb$var$applyOp(state, op, index);
        $8c2a8c8b99afbccb$var$validateState(state, index);
        resolved.push({
            index: index,
            title: step.title ?? "",
            caption: step.caption ?? "",
            body: step.body ?? "",
            state: state,
            focus: $8c2a8c8b99afbccb$var$resolveFocus(step, state)
        });
        previous = state;
    });
    return resolved;
}


const $5ce5dd87886cfa4a$export$4923170e743afeed = 1500;
/** Layer direction. Top-down keeps both stories close to the stage's shape. */ const $5ce5dd87886cfa4a$var$DIRECTION = "DOWN";
const $5ce5dd87886cfa4a$var$EDGE_LABEL_SIZE = 11;
const $5ce5dd87886cfa4a$var$EDGE_LABEL_PAD_X = 10;
const $5ce5dd87886cfa4a$var$EDGE_LABEL_HEIGHT = 16;
const $5ce5dd87886cfa4a$export$6e46f76f4f84bba8 = 12;
const $5ce5dd87886cfa4a$var$GROUP_LABEL_TRACKING = 0.12;
const $5ce5dd87886cfa4a$export$4df1f7c6b0043dc6 = 9;
const $5ce5dd87886cfa4a$export$53541954ec96f837 = 16;
const $5ce5dd87886cfa4a$export$5018354440d8c240 = 12;
/** Clear space kept between a legend plate and an edge crossing the panel border. */ const $5ce5dd87886cfa4a$var$LEGEND_CLEARANCE = 6;
/** Layout passes allowed for making room under legends that edges crossed. */ const $5ce5dd87886cfa4a$var$LEGEND_PASSES = 3;
function $5ce5dd87886cfa4a$export$5f43ccd13ed5b102(layout, nodeIds, groupIds) {
    let x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    const all = !nodeIds && !groupIds;
    const extend = (ax, ay, bx, by)=>{
        x0 = Math.min(x0, ax);
        y0 = Math.min(y0, ay);
        x1 = Math.max(x1, bx);
        y1 = Math.max(y1, by);
    };
    for (const n of layout.nodes)if (all || nodeIds?.has(n.id)) extend(n.x - n.width / 2, n.y - n.height / 2, n.x + n.width / 2, n.y + n.height / 2);
    for (const g of layout.groups)if (all || groupIds?.has(g.id)) extend(g.box.x, g.box.y - $5ce5dd87886cfa4a$export$53541954ec96f837 / 2, g.box.x + g.box.width, g.box.y + g.box.height);
    if (all) {
        for (const e of layout.edges)for (const p of e.points)extend(p.x, p.y, p.x, p.y);
    }
    if (x0 === Infinity) return null;
    return {
        x: x0,
        y: y0,
        width: x1 - x0,
        height: y1 - y0
    };
}
const $5ce5dd87886cfa4a$var$KIND_SHAPES = {
    machine: "rect",
    tool: "rect",
    service: "pill",
    chat: "pill",
    model: "pill",
    agent: "circle",
    human: "circle",
    skill: "diamond",
    repo: "hex"
};
function $5ce5dd87886cfa4a$export$50a69ea7dd5706fc(kind) {
    return kind && $5ce5dd87886cfa4a$var$KIND_SHAPES[kind] || "circle";
}
function $5ce5dd87886cfa4a$export$9521120b43092a8d(label, measure) {
    if (!label) return 0;
    const text = label.toUpperCase();
    const tracking = text.length * $5ce5dd87886cfa4a$export$6e46f76f4f84bba8 * $5ce5dd87886cfa4a$var$GROUP_LABEL_TRACKING;
    return measure(text, $5ce5dd87886cfa4a$export$6e46f76f4f84bba8) + tracking + $5ce5dd87886cfa4a$export$4df1f7c6b0043dc6 * 2;
}
let $5ce5dd87886cfa4a$var$sharedElk = null;

var $68b55976dcae3ce4$exports = {};
var $56b621a6dd25b2cb$exports = {};
"use strict";
$56b621a6dd25b2cb$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};


let $68b55976dcae3ce4$var$url = new URL("../../elk-worker.min.414ac802.js", import.meta.url);
$68b55976dcae3ce4$exports = $56b621a6dd25b2cb$exports($68b55976dcae3ce4$var$url.toString(), $68b55976dcae3ce4$var$url.origin, true);



/**
 * ELK runs in a worker: a layered layout of a busy step takes a few hundred
 * milliseconds, which would otherwise be a long task on the reader's scroll.
 * Where workers are unavailable the bundled build runs on the main thread.
 */ function $5ce5dd87886cfa4a$var$elk() {
    if (!$5ce5dd87886cfa4a$var$sharedElk) $5ce5dd87886cfa4a$var$sharedElk = (async ()=>{
        if (typeof Worker !== "undefined") {
            const { default: ElkApi } = await (parcelRequire("gPMXL"));
            return new ElkApi({
                workerFactory: ()=>new Worker($68b55976dcae3ce4$exports)
            });
        }
        const { default: ElkBundled } = await (parcelRequire("1QDgf"));
        return new ElkBundled();
    })();
    return $5ce5dd87886cfa4a$var$sharedElk;
}
class $5ce5dd87886cfa4a$export$2e2bcd8739ae039 {
    /** `story` is every state the layout will be asked for; siblings are ordered by all of them. */ constructor(story, measure = (0, $d6891e08b5dc252b$export$d53f15ae72d7df7)){
        this.measure = measure;
        this.affinity = (0, $63cf74f2526d32c7$export$ddd3b0171c32bcf0)(story, (0, $8c2a8c8b99afbccb$export$a8b6f19ec1c8d472));
    }
    async compute(state) {
        const groupById = new Map(state.groups.map((g)=>[
                g.id,
                g
            ]));
        const cards = new Map();
        for (const spec of state.nodes){
            const card = (0, $d6891e08b5dc252b$export$a86b57470971f86f)(spec.label ?? spec.id, spec.sublabel ?? "", this.measure);
            // Text is not scaled, so a smaller card never gets narrower than its label.
            const scale = spec.size ?? 1;
            cards.set(spec.id, {
                width: card.width * Math.max(1, scale),
                height: card.height * scale
            });
        }
        const edgeLabels = new Map();
        for (const spec of state.edges)if (spec.label) edgeLabels.set((0, $8c2a8c8b99afbccb$export$a8b6f19ec1c8d472)(spec), {
            width: this.measure(spec.label, $5ce5dd87886cfa4a$var$EDGE_LABEL_SIZE) + $5ce5dd87886cfa4a$var$EDGE_LABEL_PAD_X,
            height: $5ce5dd87886cfa4a$var$EDGE_LABEL_HEIGHT
        });
        const groupLabels = new Map();
        for (const spec of state.groups)if (spec.label) groupLabels.set(spec.id, {
            width: $5ce5dd87886cfa4a$export$9521120b43092a8d(spec.label, this.measure),
            height: $5ce5dd87886cfa4a$export$53541954ec96f837
        });
        // A legend with no clear run on its panel's border gets room of its own,
        // and the step is laid out again. Rarely needed, and bounded.
        const legendRoom = new Set();
        let layout = null;
        for(let pass = 0; pass < $5ce5dd87886cfa4a$var$LEGEND_PASSES; pass++){
            const { graph: graph, reversed: reversed } = (0, $63cf74f2526d32c7$export$bccc106c6d23c5a6)({
                state: state,
                direction: $5ce5dd87886cfa4a$var$DIRECTION,
                cards: cards,
                edgeLabels: edgeLabels,
                groupLabels: groupLabels,
                edgeId: $8c2a8c8b99afbccb$export$a8b6f19ec1c8d472,
                affinity: this.affinity,
                legendRoom: legendRoom
            });
            const placement = (0, $63cf74f2526d32c7$export$a831ad147daba410)(await (await $5ce5dd87886cfa4a$var$elk()).layout(graph), new Set(groupById.keys()), reversed);
            const { layout: attempt, blocked: blocked } = this.assemble(state, placement, cards, groupLabels);
            layout = attempt;
            const fresh = blocked.filter((id)=>!legendRoom.has(id));
            if (fresh.length === 0) break;
            for (const id of fresh)legendRoom.add(id);
        }
        return layout;
    }
    assemble(state, placement, cards, groupLabels) {
        const groupById = new Map(state.groups.map((g)=>[
                g.id,
                g
            ]));
        const depthOf = (spec)=>{
            let depth = 0;
            for(let parent = spec.parent; parent !== undefined; parent = groupById.get(parent)?.parent)depth++;
            return depth;
        };
        const nodes = state.nodes.map((spec)=>{
            const path = [];
            for(let group = spec.group; group !== undefined; group = groupById.get(group)?.parent)path.unshift(group);
            const centre = placement.nodes.get(spec.id);
            const card = cards.get(spec.id);
            if (!centre) throw new Error(`layout lost node "${spec.id}"`);
            return {
                id: spec.id,
                spec: spec,
                x: centre.x,
                y: centre.y,
                width: card.width,
                height: card.height,
                shape: spec.shape ?? $5ce5dd87886cfa4a$export$50a69ea7dd5706fc(spec.kind),
                color: spec.color ?? "tx2",
                path: path
            };
        });
        const edges = state.edges.map((spec)=>{
            const id = (0, $8c2a8c8b99afbccb$export$a8b6f19ec1c8d472)(spec);
            const route = placement.edges.get(id);
            if (!route) throw new Error(`layout lost edge "${id}"`);
            return {
                id: id,
                spec: spec,
                color: spec.color ?? "tx3",
                points: route.points,
                label: route.label
            };
        });
        const groups = state.groups.map((spec)=>{
            const box = placement.groups.get(spec.id);
            if (!box) throw new Error(`layout lost group "${spec.id}"`);
            return {
                id: spec.id,
                spec: spec,
                depth: depthOf(spec),
                color: spec.color ?? "tx3",
                box: box,
                legend: null
            };
        }).sort((a, b)=>a.depth - b.depth);
        const blocked = [];
        for (const group of groups){
            const placed = $5ce5dd87886cfa4a$var$placeLegend(group, groupLabels.get(group.id), edges);
            group.legend = placed?.box ?? null;
            if (placed && !placed.clear) blocked.push(group.id);
        }
        return {
            layout: {
                width: placement.width,
                height: placement.height,
                nodes: nodes,
                edges: edges,
                groups: groups
            },
            blocked: blocked
        };
    }
}
/**
 * The legend sits on the panel's top border, where edges entering the group
 * cross it. It starts at the left and slides right past any crossing; a
 * border too crowded for that puts it on the bottom border instead, where
 * only edges leaving the group cross. No edge runs through a title.
 */ function $5ce5dd87886cfa4a$var$placeLegend(group, size, edges) {
    if (!size) return null;
    const { box: box } = group;
    const start = box.x + $5ce5dd87886cfa4a$export$5018354440d8c240 - $5ce5dd87886cfa4a$export$4df1f7c6b0043dc6;
    const limit = box.x + box.width - $5ce5dd87886cfa4a$export$4df1f7c6b0043dc6;
    for (const y of [
        box.y,
        box.y + box.height
    ]){
        const spans = [];
        for (const edge of edges)for(let i = 1; i < edge.points.length; i++){
            const a = edge.points[i - 1];
            const b = edge.points[i];
            if (Math.min(a.y, b.y) <= y + size.height / 2 && Math.max(a.y, b.y) >= y - size.height / 2) spans.push([
                Math.min(a.x, b.x) - $5ce5dd87886cfa4a$var$LEGEND_CLEARANCE,
                Math.max(a.x, b.x) + $5ce5dd87886cfa4a$var$LEGEND_CLEARANCE
            ]);
        }
        spans.sort((a, b)=>a[0] - b[0]);
        let x = start;
        for (const [from, to] of spans){
            if (to < x || from > x + size.width) continue;
            x = to;
        }
        if (x + size.width <= limit) return {
            box: {
                x: x,
                y: y - size.height / 2,
                width: size.width,
                height: size.height
            },
            clear: true
        };
    }
    // Nowhere clear on either border: keep the conventional spot for now.
    return {
        box: {
            x: start,
            y: box.y - size.height / 2,
            width: size.width,
            height: size.height
        },
        clear: false
    };
}



var $2YFJl = parcelRequire("2YFJl");


const $ef5ea0a323b94b0c$var$ACCENTS = [
    "red",
    "orange",
    "yellow",
    "green",
    "cyan",
    "blue",
    "purple",
    "magenta",
    "tx",
    "tx2",
    "tx3"
];
const $ef5ea0a323b94b0c$var$ARROW_GAP = 6;
// Named transitions so fades and geometry tweens on one element run together
// instead of interrupting each other.
const $ef5ea0a323b94b0c$var$FADE = "gs-fade";
const $ef5ea0a323b94b0c$var$MOVE = "gs-move";
const $ef5ea0a323b94b0c$var$CAMERA = "gs-camera";
/** Corner radius on a routed edge; kept under half the layout's edge spacing. */ const $ef5ea0a323b94b0c$var$ELBOW_RADIUS = 6;
/** Points a route is resampled to when it morphs into one with a different shape. */ const $ef5ea0a323b94b0c$var$MORPH_SAMPLES = 24;
/**
 * Text centres inside the card, relative to its centre. Two lines are centred
 * as a block: 15px over 11px with a small gap is 29 units tall.
 */ const $ef5ea0a323b94b0c$var$LABEL_BASELINE = 0;
const $ef5ea0a323b94b0c$var$LABEL_BASELINE_TWO_LINE = -7;
const $ef5ea0a323b94b0c$var$SUBLABEL_BASELINE = 9;
function $ef5ea0a323b94b0c$var$timingFor(duration) {
    return {
        // Strictly sequential phases: things leave, the rest rearranges, new things
        // appear into the finished layout.
        exit: {
            delay: 0,
            duration: duration * 0.35
        },
        move: {
            delay: duration * 0.3,
            duration: duration * 0.7
        },
        enter: {
            delay: duration * 0.95,
            duration: duration * 0.45
        }
    };
}
let $ef5ea0a323b94b0c$var$instanceCounter = 0;
class $ef5ea0a323b94b0c$export$2e2bcd8739ae039 {
    constructor(svg, width, height){
        /** Position currently painted for each node; tweens converge on the layout target. */ this.painted = new Map();
        /** Route currently painted for each edge, so a changed route morphs from where it is. */ this.routes = new Map();
        /** Ids that stay fully lit; null means nothing is dimmed. */ this.lit = null;
        /** Label centre currently painted per edge. */ this.labels = new Map();
        this.uid = `gs${$ef5ea0a323b94b0c$var$instanceCounter++}`;
        this.svg = $2YFJl.select(svg).attr("viewBox", `0 0 ${width} ${height}`).attr("preserveAspectRatio", "xMidYMid meet");
        const defs = this.svg.append("defs");
        for (const accent of $ef5ea0a323b94b0c$var$ACCENTS)defs.append("marker").attr("id", `${this.uid}-arrow-${accent}`).attr("class", `gs-arrow is-color-${accent}`).attr("viewBox", "0 0 10 10").attr("refX", 9).attr("refY", 5).attr("markerWidth", 7).attr("markerHeight", 7).attr("orient", "auto-start-reverse").append("path").attr("d", "M0,1L9,5L0,9Z");
        this.groupLayer = this.svg.append("g").attr("class", "gs-groups");
        this.edgeLayer = this.svg.append("g").attr("class", "gs-edges");
        this.nodeLayer = this.svg.append("g").attr("class", "gs-nodes");
    }
    render(layout, duration, focus) {
        const timing = $ef5ea0a323b94b0c$var$timingFor(duration);
        this.lit = focus && !focus.all ? $ef5ea0a323b94b0c$var$litSet(layout, focus) : null;
        this.svg.classed("is-focused", this.lit !== null);
        // Nodes first so their tweens run before edges read `px`/`py` each frame.
        this.renderNodes(layout.nodes, timing);
        this.renderEdges(layout.edges, timing);
        this.renderGroups(layout.groups, timing);
    }
    dimNode(n) {
        return this.lit !== null && !this.lit.nodes.has(n.id);
    }
    /** Animates the viewBox to frame `box`. */ setCamera(box, duration) {
        const view = `${box.x.toFixed(1)} ${box.y.toFixed(1)} ${box.width.toFixed(1)} ${box.height.toFixed(1)}`;
        if (duration === 0) {
            this.svg.interrupt($ef5ea0a323b94b0c$var$CAMERA).attr("viewBox", view);
            return;
        }
        this.svg.transition($ef5ea0a323b94b0c$var$CAMERA).duration(duration).ease($2YFJl.easeCubicInOut).attr("viewBox", view);
    }
    renderGroups(groups, timing) {
        const sel = this.groupLayer.selectAll("g.gs-group:not(.is-exiting)").data(groups, (g)=>g.id);
        const enter = sel.enter().append("g").attr("class", "gs-group").style("opacity", 0);
        enter.append("rect").attr("class", "gs-group__panel");
        // A plate that knocks the label out of the panel border, like a TUI title.
        enter.append("rect").attr("class", "gs-group__legend");
        enter.append("text").attr("class", "gs-group__label");
        enter.select("rect.gs-group__panel").call($ef5ea0a323b94b0c$var$placePanel);
        enter.select("text.gs-group__label").call($ef5ea0a323b94b0c$var$placeGroupLabel);
        enter.select("rect.gs-group__legend").call($ef5ea0a323b94b0c$var$placeLegend);
        enter.transition($ef5ea0a323b94b0c$var$FADE).delay(timing.enter.delay).duration(timing.enter.duration).style("opacity", 1);
        sel.exit().classed("is-exiting", true).transition($ef5ea0a323b94b0c$var$FADE).delay(timing.exit.delay).duration(timing.exit.duration).style("opacity", 0).remove();
        const merged = enter.merge(sel).sort((a, b)=>a.depth - b.depth);
        merged.attr("class", (g)=>`gs-group is-color-${g.color} is-depth-${g.depth}${this.lit && !this.lit.groups.has(g.id) ? " is-dim" : ""}`);
        merged.select("text.gs-group__label").text((g)=>g.spec.label ?? "");
        const updated = sel.transition($ef5ea0a323b94b0c$var$MOVE).delay(timing.move.delay).duration(timing.move.duration).ease($2YFJl.easeCubicInOut);
        updated.select("rect.gs-group__panel").call($ef5ea0a323b94b0c$var$placePanel);
        updated.select("text.gs-group__label").call($ef5ea0a323b94b0c$var$placeGroupLabel);
        updated.select("rect.gs-group__legend").call($ef5ea0a323b94b0c$var$placeLegend);
    }
    renderNodes(nodes, timing) {
        const sel = this.nodeLayer.selectAll("g.gs-node:not(.is-exiting)").data(nodes, (n)=>n.id);
        const enter = sel.enter().append("g").attr("class", "gs-node").attr("transform", (n)=>`translate(${n.x},${n.y})`).style("opacity", 0);
        enter.append("path").attr("class", "gs-node__shape").attr("d", (n)=>(0, $d6891e08b5dc252b$export$6755aabc83e985ab)(n.shape, n.width, n.height)).attr("transform", "scale(0.86)");
        enter.append("text").attr("class", "gs-node__sigil").attr("x", (n)=>(0, $d6891e08b5dc252b$export$31cab2e20805d3be)(n.width)).attr("y", (n)=>n.spec.sublabel ? $ef5ea0a323b94b0c$var$LABEL_BASELINE_TWO_LINE : $ef5ea0a323b94b0c$var$LABEL_BASELINE).text((n)=>(0, $d6891e08b5dc252b$export$7da6558600d0a5d8)(n.spec.kind));
        enter.append("text").attr("class", "gs-node__label").attr("x", (n)=>(0, $d6891e08b5dc252b$export$6919871dc0d016c5)(n.width)).attr("y", (n)=>n.spec.sublabel ? $ef5ea0a323b94b0c$var$LABEL_BASELINE_TWO_LINE : $ef5ea0a323b94b0c$var$LABEL_BASELINE);
        enter.append("text").attr("class", "gs-node__sublabel").attr("x", (n)=>(0, $d6891e08b5dc252b$export$6919871dc0d016c5)(n.width)).attr("y", $ef5ea0a323b94b0c$var$SUBLABEL_BASELINE);
        const entering = enter.transition($ef5ea0a323b94b0c$var$FADE).delay(timing.enter.delay).duration(timing.enter.duration).ease($2YFJl.easeBackOut);
        entering.style("opacity", 1);
        entering.select("path").attr("transform", "scale(1)");
        const exiting = sel.exit().classed("is-exiting", true).transition($ef5ea0a323b94b0c$var$FADE).delay(timing.exit.delay).duration(timing.exit.duration).style("opacity", 0);
        exiting.select("path").attr("transform", "scale(0.86)");
        exiting.remove();
        const merged = enter.merge(sel);
        merged.attr("class", (n)=>`gs-node is-shape-${n.shape} is-color-${n.color} is-state-${n.spec.state ?? "default"}${n.spec.kind ? ` is-kind-${n.spec.kind}` : ""}${this.dimNode(n) ? " is-dim" : ""}`);
        merged.select("text.gs-node__sigil").text((n)=>(0, $d6891e08b5dc252b$export$7da6558600d0a5d8)(n.spec.kind));
        merged.select("text.gs-node__sublabel").call($ef5ea0a323b94b0c$var$swapText, (n)=>n.spec.sublabel ?? "", timing);
        merged.select("text.gs-node__label").call($ef5ea0a323b94b0c$var$swapText, (n)=>n.spec.label ?? n.id, timing);
        for (const n of nodes)if (!this.painted.has(n.id)) this.painted.set(n.id, {
            x: n.x,
            y: n.y
        });
        const moving = sel.transition($ef5ea0a323b94b0c$var$MOVE).delay(timing.move.delay).duration(timing.move.duration).ease($2YFJl.easeCubicInOut);
        moving.attrTween("transform", (n)=>{
            const p = this.paintedOf(n);
            const ix = $2YFJl.interpolateNumber(p.x, n.x);
            const iy = $2YFJl.interpolateNumber(p.y, n.y);
            return (t)=>{
                p.x = ix(t);
                p.y = iy(t);
                return `translate(${p.x},${p.y})`;
            };
        });
        moving.select("path").attr("d", (n)=>(0, $d6891e08b5dc252b$export$6755aabc83e985ab)(n.shape, n.width, n.height));
        moving.select("text.gs-node__sigil").attr("x", (n)=>(0, $d6891e08b5dc252b$export$31cab2e20805d3be)(n.width)).attr("y", (n)=>n.spec.sublabel ? $ef5ea0a323b94b0c$var$LABEL_BASELINE_TWO_LINE : $ef5ea0a323b94b0c$var$LABEL_BASELINE);
        moving.select("text.gs-node__label").attr("x", (n)=>(0, $d6891e08b5dc252b$export$6919871dc0d016c5)(n.width)).attr("y", (n)=>n.spec.sublabel ? $ef5ea0a323b94b0c$var$LABEL_BASELINE_TWO_LINE : $ef5ea0a323b94b0c$var$LABEL_BASELINE);
        moving.select("text.gs-node__sublabel").attr("x", (n)=>(0, $d6891e08b5dc252b$export$6919871dc0d016c5)(n.width));
        if (timing.move.duration === 0) for (const n of nodes)this.painted.set(n.id, {
            x: n.x,
            y: n.y
        });
    }
    paintedOf(n) {
        let p = this.painted.get(n.id);
        if (!p) {
            p = {
                x: n.x,
                y: n.y
            };
            this.painted.set(n.id, p);
        }
        return p;
    }
    renderEdges(edges, timing) {
        const sel = this.edgeLayer.selectAll("g.gs-edge:not(.is-exiting)").data(edges, (e)=>e.id);
        const enter = sel.enter().append("g").attr("class", "gs-edge").style("opacity", 0);
        enter.append("path").attr("class", "gs-edge__line");
        // A plate behind the label so the line does not run through the text.
        enter.append("rect").attr("class", "gs-edge__plate").attr("rx", 1);
        enter.append("text").attr("class", "gs-edge__label");
        enter.transition($ef5ea0a323b94b0c$var$FADE).delay(timing.enter.delay).duration(timing.enter.duration).style("opacity", 1);
        const exiting = new Set();
        sel.exit().each((e)=>exiting.add(e.id)).classed("is-exiting", true).transition($ef5ea0a323b94b0c$var$FADE).delay(timing.exit.delay).duration(timing.exit.duration).style("opacity", 0).remove();
        for (const id of exiting)this.routes.delete(id);
        const merged = enter.merge(sel);
        merged.attr("class", (e)=>`gs-edge is-color-${e.color} is-style-${e.spec.style ?? "solid"} is-state-${e.spec.state ?? "default"}${this.lit && !this.lit.edges.has(e.id) ? " is-dim" : ""}`);
        merged.select("path").attr("marker-end", (e)=>e.spec.directed === false ? null : `url(#${this.uid}-arrow-${e.color})`);
        merged.select("text").text((e)=>e.spec.label ?? "");
        merged.select("rect.gs-edge__plate").each(function(e) {
            const plate = $2YFJl.select(this);
            if (!e.label) {
                plate.attr("x", null).attr("y", null).attr("width", 0).attr("height", 0);
                return;
            }
            plate.attr("x", -e.label.width / 2).attr("y", -e.label.height / 2).attr("width", e.label.width).attr("height", e.label.height);
        });
        // New edges appear on their final route once the cards have arrived.
        enter.select("path").attr("d", (e)=>$ef5ea0a323b94b0c$var$roundedPolyline(this.finalRoute(e), $ef5ea0a323b94b0c$var$ELBOW_RADIUS));
        enter.select("text").attr("transform", (e)=>$ef5ea0a323b94b0c$var$labelTransform(e, 1, null));
        enter.select("rect.gs-edge__plate").attr("transform", (e)=>$ef5ea0a323b94b0c$var$labelTransform(e, 1, null));
        const previous = new Map();
        sel.each((e)=>{
            const route = this.routes.get(e.id);
            if (route) previous.set(e.id, {
                route: route,
                label: this.labels.get(e.id) ?? null
            });
        });
        // Existing edges morph from the route they had into the new one, in step
        // with the cards they connect.
        const moving = sel.transition($ef5ea0a323b94b0c$var$MOVE).delay(timing.move.delay).duration(timing.move.duration).ease($2YFJl.easeCubicInOut);
        moving.select("path").attrTween("d", (e)=>{
            const target = this.finalRoute(e);
            const from = previous.get(e.id)?.route ?? target;
            const morph = $ef5ea0a323b94b0c$var$morphRoutes(from, target);
            return (t)=>t >= 1 ? $ef5ea0a323b94b0c$var$roundedPolyline(target, $ef5ea0a323b94b0c$var$ELBOW_RADIUS) : $ef5ea0a323b94b0c$var$roundedPolyline(morph(t), $ef5ea0a323b94b0c$var$ELBOW_RADIUS);
        });
        moving.select("text").attrTween("transform", (e)=>(t)=>$ef5ea0a323b94b0c$var$labelTransform(e, t, previous.get(e.id)?.label ?? null));
        moving.select("rect.gs-edge__plate").attrTween("transform", (e)=>(t)=>$ef5ea0a323b94b0c$var$labelTransform(e, t, previous.get(e.id)?.label ?? null));
        if (timing.move.duration === 0) {
            merged.select("path").attr("d", (e)=>$ef5ea0a323b94b0c$var$roundedPolyline(this.finalRoute(e), $ef5ea0a323b94b0c$var$ELBOW_RADIUS));
            merged.select("text").attr("transform", (e)=>$ef5ea0a323b94b0c$var$labelTransform(e, 1, null));
            merged.select("rect.gs-edge__plate").attr("transform", (e)=>$ef5ea0a323b94b0c$var$labelTransform(e, 1, null));
        }
        for (const e of edges){
            this.routes.set(e.id, this.finalRoute(e));
            this.labels.set(e.id, $ef5ea0a323b94b0c$var$labelCentre(e));
        }
    }
    /** The layout's route, pulled back at the target so the arrowhead's tip meets the card. */ finalRoute(e) {
        const gap = e.spec.directed === false ? 1 : $ef5ea0a323b94b0c$var$ARROW_GAP;
        return $ef5ea0a323b94b0c$var$trimEnd(e.points, gap);
    }
}
/** Fades a text element out, swaps its content, and fades it back in when the text changed. */ function $ef5ea0a323b94b0c$var$swapText(sel, value, timing) {
    sel.each(function(n) {
        const el = $2YFJl.select(this);
        const next = value(n);
        if (el.text() === next) return;
        if (timing.move.duration === 0 || el.text() === "") {
            el.text(next);
            return;
        }
        const half = timing.move.duration / 2;
        el.transition($ef5ea0a323b94b0c$var$FADE).delay(timing.move.delay).duration(half).style("fill-opacity", 0).style("stroke-opacity", 0).transition().duration(0).text(next).transition().duration(half).style("fill-opacity", 1).style("stroke-opacity", 1)// Leave no inline style behind, so a replayed step matches a jumped-to one.
        .on("end", function() {
            $2YFJl.select(this).style("fill-opacity", null).style("stroke-opacity", null);
            if (!this.getAttribute("style")) this.removeAttribute("style");
        });
    });
}
/** Lit set: focused nodes, members of focused groups, and the groups that contain any lit node. */ function $ef5ea0a323b94b0c$var$litSet(layout, focus) {
    const nodes = new Set(focus.nodes);
    for (const n of layout.nodes)if (n.path.some((g)=>focus.groups.has(g))) nodes.add(n.id);
    const groups = new Set([
        ...focus.groups,
        ...focus.panels
    ]);
    for (const n of layout.nodes){
        if (nodes.has(n.id)) for (const g of n.path)groups.add(g);
    }
    return {
        nodes: nodes,
        groups: groups,
        edges: new Set(focus.edges)
    };
}
function $ef5ea0a323b94b0c$var$placePanel(sel) {
    sel.attr("x", (g)=>g.box.x).attr("y", (g)=>g.box.y).attr("width", (g)=>g.box.width).attr("height", (g)=>g.box.height);
}
function $ef5ea0a323b94b0c$var$placeGroupLabel(sel) {
    sel.attr("x", (g)=>g.legend ? g.legend.x + (0, $5ce5dd87886cfa4a$export$4df1f7c6b0043dc6) : g.box.x).attr("y", (g)=>g.legend ? g.legend.y + g.legend.height / 2 : g.box.y);
}
/** Plate sized to the label so the panel border is interrupted, not overdrawn; placed by the layout clear of edges. */ function $ef5ea0a323b94b0c$var$placeLegend(sel) {
    sel.attr("x", (g)=>g.legend?.x ?? g.box.x).attr("y", (g)=>g.legend?.y ?? g.box.y).attr("width", (g)=>g.legend?.width ?? 0).attr("height", (g)=>g.legend?.height ?? 0);
}
function $ef5ea0a323b94b0c$var$labelCentre(e) {
    return e.label ? {
        x: e.label.x + e.label.width / 2,
        y: e.label.y + e.label.height / 2
    } : null;
}
function $ef5ea0a323b94b0c$var$labelTransform(e, t, from) {
    const to = $ef5ea0a323b94b0c$var$labelCentre(e) ?? $ef5ea0a323b94b0c$var$polylineMidpoint(e.points);
    const start = from ?? to;
    const x = start.x + (to.x - start.x) * t;
    const y = start.y + (to.y - start.y) * t;
    return `translate(${x.toFixed(1)},${y.toFixed(1)})`;
}
/** Shortens a route's last segment so an arrowhead drawn at its end stops at the card. */ function $ef5ea0a323b94b0c$var$trimEnd(points, gap) {
    if (points.length < 2) return points;
    const out = points.map((p)=>({
            ...p
        }));
    const last = out[out.length - 1];
    const before = out[out.length - 2];
    const length = Math.hypot(last.x - before.x, last.y - before.y);
    if (length <= gap * 2) return out;
    last.x -= (last.x - before.x) / length * gap;
    last.y -= (last.y - before.y) / length * gap;
    return out;
}
/**
 * Interpolates one route into another. Routes with the same number of points
 * move corner by corner, which keeps every segment orthogonal on the way;
 * otherwise both are resampled evenly by length.
 */ function $ef5ea0a323b94b0c$var$morphRoutes(from, to) {
    const a = from.length === to.length ? from : $ef5ea0a323b94b0c$var$resample(from, $ef5ea0a323b94b0c$var$MORPH_SAMPLES);
    const b = from.length === to.length ? to : $ef5ea0a323b94b0c$var$resample(to, $ef5ea0a323b94b0c$var$MORPH_SAMPLES);
    return (t)=>a.map((p, i)=>({
                x: p.x + (b[i].x - p.x) * t,
                y: p.y + (b[i].y - p.y) * t
            }));
}
function $ef5ea0a323b94b0c$var$resample(points, count) {
    const lengths = [
        0
    ];
    for(let i = 1; i < points.length; i++)lengths.push(lengths[i - 1] + Math.hypot(points[i].x - points[i - 1].x, points[i].y - points[i - 1].y));
    const total = lengths[lengths.length - 1] || 1;
    const out = [];
    let segment = 1;
    for(let k = 0; k < count; k++){
        const at = total * k / (count - 1);
        while(segment < points.length - 1 && lengths[segment] < at)segment++;
        const span = lengths[segment] - lengths[segment - 1] || 1;
        const t = Math.min(1, Math.max(0, (at - lengths[segment - 1]) / span));
        const a = points[segment - 1];
        const b = points[segment] ?? a;
        out.push({
            x: a.x + (b.x - a.x) * t,
            y: a.y + (b.y - a.y) * t
        });
    }
    return out;
}
/** Polyline with the corners rounded, clamped so short segments stay clean. */ function $ef5ea0a323b94b0c$var$roundedPolyline(points, radius) {
    const parts = [
        `M${points[0].x.toFixed(1)},${points[0].y.toFixed(1)}`
    ];
    for(let i = 1; i < points.length - 1; i++){
        const previous = points[i - 1];
        const corner = points[i];
        const next = points[i + 1];
        const inLength = Math.hypot(corner.x - previous.x, corner.y - previous.y);
        const outLength = Math.hypot(next.x - corner.x, next.y - corner.y);
        const r = Math.min(radius, inLength / 2, outLength / 2);
        if (r < 1) {
            parts.push(`L${corner.x.toFixed(1)},${corner.y.toFixed(1)}`);
            continue;
        }
        const enter = {
            x: corner.x + (previous.x - corner.x) / inLength * r,
            y: corner.y + (previous.y - corner.y) / inLength * r
        };
        const leave = {
            x: corner.x + (next.x - corner.x) / outLength * r,
            y: corner.y + (next.y - corner.y) / outLength * r
        };
        parts.push(`L${enter.x.toFixed(1)},${enter.y.toFixed(1)}`);
        parts.push(`Q${corner.x.toFixed(1)},${corner.y.toFixed(1)} ${leave.x.toFixed(1)},${leave.y.toFixed(1)}`);
    }
    const last = points[points.length - 1];
    parts.push(`L${last.x.toFixed(1)},${last.y.toFixed(1)}`);
    return parts.join("");
}
/** Point halfway along a polyline, by length. */ function $ef5ea0a323b94b0c$var$polylineMidpoint(points) {
    let total = 0;
    for(let i = 1; i < points.length; i++)total += Math.hypot(points[i].x - points[i - 1].x, points[i].y - points[i - 1].y);
    let travelled = 0;
    for(let i = 1; i < points.length; i++){
        const segment = Math.hypot(points[i].x - points[i - 1].x, points[i].y - points[i - 1].y);
        if (travelled + segment >= total / 2) {
            const t = segment === 0 ? 0 : (total / 2 - travelled) / segment;
            return {
                x: points[i - 1].x + (points[i].x - points[i - 1].x) * t,
                y: points[i - 1].y + (points[i].y - points[i - 1].y) * t
            };
        }
        travelled += segment;
    }
    return points[points.length - 1];
}




const $4fbea733151196ee$var$DEFAULT_DURATION = 900;
const $4fbea733151196ee$var$DEFAULT_INTERVAL = 2600;
const $4fbea733151196ee$var$CAMERA_PADDING = 70;
/** How long a queued scroll-mode jump keeps steering next/prev, in ms. */ const $4fbea733151196ee$var$PENDING_TTL = 1200;
/** A focused view never zooms in past this share of the layout width. */ const $4fbea733151196ee$var$MIN_VIEW_SHARE = 0.55;
/** Share of the centred square the focus fills; the rest is breathing room. */ const $4fbea733151196ee$var$CONTENT_FILL = 0.84;
/** Stage widths below this are treated as a phone. */ const $4fbea733151196ee$var$NARROW_STAGE_PX = 560;
/**
 * A phone never zooms in past this share of the layout width, so a step with
 * one or two cards does not blow up to fill the screen. There is no cap the
 * other way: every card a step lights must be in frame, because the stage
 * cannot be panned.
 */ const $4fbea733151196ee$var$PORTRAIT_MIN_SHARE = 0.24;
/**
 * Smallest on-screen card label a phone frame accepts for context. The
 * cards a step itself changes are always framed, however small that makes
 * them; cards lit only as the far end of a new edge are added while labels
 * stay at least this size, and can be panned to otherwise.
 */ const $4fbea733151196ee$var$READABLE_LABEL_PX = 8;
/** Share of the stage at each edge the SVG mask fades out (graph-story.scss). */ const $4fbea733151196ee$var$EDGE_FADE = 0.08;
/** How long a tap on an edge marker takes to pan, in ms. */ const $4fbea733151196ee$var$MARKER_PAN_MS = 450;
const $4fbea733151196ee$var$SCROLL_STEP_HEIGHT_VH = 65;
/** How many layouts to request ahead of the reader. */ const $4fbea733151196ee$var$WARM_AHEAD = 4;
class $4fbea733151196ee$export$2e2bcd8739ae039 {
    static{
        this.selectors = {
            root: "graph-story"
        };
    }
    constructor(container, spec, options = {}){
        /** Layout requests per step; each step is laid out once and replayed from here. */ this.layouts = [];
        /** Layouts that have arrived, for code that cannot wait (resize). */ this.ready = [];
        /** Step whose layout is on screen; trails `index` while a layout is in flight. */ this.shown = -1;
        this.viewAspect = 1.6;
        this.stageWidthPx = 0;
        this.svg = null;
        /** What the camera shows now: a step sets it, dragging moves it. */ this.view = null;
        /** Edge markers pointing at lit cards that are out of frame. */ this.markers = new Map();
        this.renderer = null;
        this.index = -1;
        this.reduceMotion = false;
        this.panels = [];
        this.panelTops = [];
        this.dots = [];
        this.playButton = null;
        /** Step a scroll-mode jump is heading for, so rapid clicks queue instead of fighting the scroll handler. */ this.pendingIndex = null;
        this.pendingAt = 0;
        this.timer = null;
        this.playing = false;
        this.scrollFrame = null;
        this.cleanups = [];
        this.container = container;
        this.spec = spec;
        this.options = options;
        this.steps = (0, $8c2a8c8b99afbccb$export$7571004462e76c36)(spec);
        this.trigger = options.trigger ?? spec.trigger ?? "click";
    }
    get current() {
        return this.index;
    }
    init() {
        const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
        this.reduceMotion = motionQuery.matches;
        const onMotionChange = ()=>{
            this.reduceMotion = motionQuery.matches;
            if (this.reduceMotion) this.pause();
        };
        motionQuery.addEventListener("change", onMotionChange);
        this.cleanups.push(()=>motionQuery.removeEventListener("change", onMotionChange));
        this.buildDom();
        this.bindControls();
        if (this.trigger === "scroll") this.bindScroll();
        else this.goTo(0, true);
        if (this.trigger === "timeline") this.bindAutoplay();
        this.bindResize();
        this.bindPan();
        this.warmLayouts();
        return this;
    }
    /**
   * The stage box changes with the window, and the camera is fitted to it, so
   * re-frame on resize. The layout itself is left alone: recomputing it would
   * move every node for what is only a change of viewport.
   */ bindResize() {
        let frame = null;
        const onResize = ()=>{
            if (frame !== null) return;
            frame = window.requestAnimationFrame(()=>{
                frame = null;
                this.panelTops = [];
                if (!this.svg || this.shown < 0) return;
                this.measureStage(this.svg);
                this.showView(this.cameraFor(this.ready[this.shown], this.steps[this.shown]), 0);
            });
        };
        window.addEventListener("resize", onResize);
        this.cleanups.push(()=>{
            window.removeEventListener("resize", onResize);
            if (frame !== null) window.cancelAnimationFrame(frame);
        });
    }
    /** Reads the stage box; the camera fits content to it, so this can change with the window. */ measureStage(svg) {
        const rect = svg.getBoundingClientRect();
        if (rect.width <= 0 || rect.height <= 0) return;
        this.stageWidthPx = rect.width;
        this.viewAspect = this.trigger === "scroll" ? Math.min(2.2, Math.max(0.55, rect.width / rect.height)) : this.spec.aspect ?? 1.6;
    }
    /**
   * Layout for a step, requested once. A step's layout depends only on its own
   * state and the story, so the order steps are visited in cannot change a picture.
   */ layoutFor(index) {
        let pending = this.layouts[index];
        if (!pending) {
            pending = this.layout.compute(this.steps[index].state).then((layout)=>{
                this.ready[index] = layout;
                return layout;
            });
            this.layouts[index] = pending;
        }
        return pending;
    }
    /**
   * Requests the next few layouts so the reader rarely waits. Layouts are
   * computed in a worker, so this costs the page nothing but a message; the
   * current step was requested first and is served first.
   */ warmLayouts() {
        const from = Math.max(this.index, 0);
        for(let i = from + 1; i < Math.min(this.steps.length, from + 1 + $4fbea733151196ee$var$WARM_AHEAD); i++)this.layoutFor(i);
    }
    destroy() {
        this.pause();
        for (const cleanup of this.cleanups.splice(0))cleanup();
        this.container.replaceChildren();
        this.container.classList.remove("is-ready");
    }
    next() {
        this.goTo(Math.min(this.steps.length - 1, this.stepCursor() + 1));
    }
    prev() {
        this.goTo(Math.max(0, this.stepCursor() - 1));
    }
    /**
   * Where the next step should be counted from. In scroll mode a jump is a
   * smooth scroll, so a click that lands mid-flight must continue from the
   * pending target rather than from whatever the scroll handler last saw.
   */ stepCursor() {
        if (this.pendingIndex === null) return this.index;
        return performance.now() - this.pendingAt < $4fbea733151196ee$var$PENDING_TTL ? this.pendingIndex : this.index;
    }
    goTo(index, immediate = false) {
        if (index === this.index || index < 0 || index >= this.steps.length) return;
        if (this.trigger === "scroll" && !immediate) {
            this.pendingIndex = index;
            this.pendingAt = performance.now();
            this.scrollToStep(index);
            return;
        }
        this.applyStep(index, immediate);
    }
    play() {
        if (this.playing) return;
        this.playing = true;
        this.playButton?.classList.add("is-playing");
        this.playButton?.setAttribute("aria-label", "Pause");
        this.tickAutoplay();
    }
    pause() {
        this.playing = false;
        this.playButton?.classList.remove("is-playing");
        this.playButton?.setAttribute("aria-label", "Play");
        if (this.timer !== null) {
            window.clearTimeout(this.timer);
            this.timer = null;
        }
    }
    applyStep(index, immediate) {
        if (index === this.index) return;
        this.index = index;
        this.updateChrome();
        this.options.onStep?.(index, this.steps[index]);
        this.layoutFor(index).then((layout)=>{
            // The reader may have moved on while this layout was in flight.
            if (this.index !== index) return;
            const jump = Math.abs(index - this.shown) > 1 || this.shown === -1;
            const duration = immediate || this.shown === -1 || this.reduceMotion ? 0 : (this.options.duration ?? $4fbea733151196ee$var$DEFAULT_DURATION) * (jump ? 0.6 : 1);
            const step = this.steps[index];
            this.shown = index;
            this.renderer?.render(layout, duration, step.focus);
            this.showView(this.cameraFor(layout, step), duration);
        });
        this.warmLayouts();
    }
    /**
   * What the camera should frame: the step's focus, plus the panels the action
   * sits in. Half a panel in frame reads as a rendering mistake.
   */ framedBounds(layout, step, portrait) {
        // On a wide stage, whole panels around the action: half a panel in frame
        // reads as a rendering mistake. On a narrow one there is no room for that,
        // so the frame holds the changed nodes and nothing else.
        const groups = new Set([
            ...step.focus.groups,
            ...step.focus.panels
        ]);
        if (!portrait) for (const node of layout.nodes){
            if (step.focus.nodes.has(node.id)) for (const id of node.path)groups.add(id);
        }
        return (0, $5ce5dd87886cfa4a$export$5f43ccd13ed5b102)(layout, step.focus.nodes, groups);
    }
    /**
   * Frames the step's focus. The frame always holds every card the step
   * lights, inside the unfaded middle of the stage: the diagram cannot be
   * panned, so anything framed out is simply lost.
   *
   * A wide stage fits the focus into a square-ish region at its centre.
   * Fitting to the stage aspect instead would stretch the content along
   * whichever axis the window happens to be long in. A phone has no room to
   * spare, so there the focus is fitted to the stage as it is.
   */ cameraFor(layout, step) {
        const full = (0, $5ce5dd87886cfa4a$export$5f43ccd13ed5b102)(layout) ?? {
            x: 0,
            y: 0,
            width: (0, $5ce5dd87886cfa4a$export$4923170e743afeed),
            height: (0, $5ce5dd87886cfa4a$export$4923170e743afeed) / this.viewAspect
        };
        const narrow = this.stageWidthPx > 0 && this.stageWidthPx < $4fbea733151196ee$var$NARROW_STAGE_PX;
        const focused = step.focus.all ? null : this.framedBounds(layout, step, narrow);
        const box = focused ?? full;
        if (narrow) return this.phoneCamera(layout, step, box);
        // Side of the centred square the content has to fit inside.
        const side = Math.max(box.width, box.height) / $4fbea733151196ee$var$CONTENT_FILL;
        let width = this.viewAspect >= 1 ? side * this.viewAspect : side;
        width = Math.max(width, (0, $5ce5dd87886cfa4a$export$4923170e743afeed) * $4fbea733151196ee$var$MIN_VIEW_SHARE);
        const height = width / this.viewAspect;
        return {
            x: box.x + box.width / 2 - width / 2,
            y: box.y + box.height / 2 - height / 2,
            width: width,
            height: height
        };
    }
    /**
   * A phone cannot show a wide step at a readable size. The cards the step
   * itself changes are always in frame; the rest of what it lights (usually
   * the far end of a new edge) joins them while labels stay readable, and is
   * otherwise a drag away, with an edge marker pointing at it.
   */ phoneCamera(layout, step, box) {
        const aspect = this.viewAspect;
        const fit = (b)=>Math.max(b.width, b.height * aspect) / $4fbea733151196ee$var$CONTENT_FILL;
        const floor = (0, $5ce5dd87886cfa4a$export$4923170e743afeed) * $4fbea733151196ee$var$PORTRAIT_MIN_SHARE;
        const readable = this.stageWidthPx * (0, $d6891e08b5dc252b$export$f07f6a1752e5a26e) / $4fbea733151196ee$var$READABLE_LABEL_PX;
        const coreIds = step.focus.core.size > 0 ? step.focus.core : step.focus.nodes;
        const core = step.focus.all ? null : (0, $5ce5dd87886cfa4a$export$5f43ccd13ed5b102)(layout, coreIds, new Set());
        const wanted = Math.max(fit(box), floor);
        const width = !core || wanted <= readable ? wanted : Math.max(fit(core), floor, readable);
        const height = width / aspect;
        // Aim at the middle of everything lit, then slide until the core sits in
        // the unfaded middle of the frame.
        let cx = box.x + box.width / 2;
        let cy = box.y + box.height / 2;
        if (core) {
            const halfW = width * $4fbea733151196ee$var$CONTENT_FILL / 2;
            const halfH = height * $4fbea733151196ee$var$CONTENT_FILL / 2;
            cx = $4fbea733151196ee$var$clamp(cx, core.x + core.width - halfW, core.x + halfW);
            cy = $4fbea733151196ee$var$clamp(cy, core.y + core.height - halfH, core.y + halfH);
        }
        return {
            x: cx - width / 2,
            y: cy - height / 2,
            width: width,
            height: height
        };
    }
    /** Moves the camera and refreshes the markers for what is now out of frame. */ showView(view, duration) {
        this.view = view;
        this.renderer?.setCamera(view, duration);
        this.updateMarkers();
    }
    /**
   * Dragging pans the diagram; two fingers pan in any direction and pinch to
   * zoom. A single finger only pans sideways: vertical swipes belong to the
   * page, which is what moves the story along. The next step resets the view.
   */ bindPan() {
        const svg = this.svg;
        if (!svg) return;
        const pointers = new Map();
        let last = null;
        const gather = ()=>{
            const points = [
                ...pointers.values()
            ];
            if (points.length === 0) return null;
            const x = points.reduce((sum, p)=>sum + p.x, 0) / points.length;
            const y = points.reduce((sum, p)=>sum + p.y, 0) / points.length;
            const spread = points.length > 1 ? Math.hypot(points[0].x - points[1].x, points[0].y - points[1].y) : 0;
            return {
                x: x,
                y: y,
                spread: spread
            };
        };
        // A camera transition may be mid-flight: start from what is on screen.
        const onScreen = ()=>{
            const vb = svg.viewBox.baseVal;
            return {
                x: vb.x,
                y: vb.y,
                width: vb.width,
                height: vb.height
            };
        };
        const down = (event)=>{
            if (event.pointerType === "mouse" && event.button !== 0) return;
            if (this.shown < 0) return;
            svg.setPointerCapture(event.pointerId);
            pointers.set(event.pointerId, {
                x: event.clientX,
                y: event.clientY
            });
            this.view = onScreen();
            last = gather();
            svg.classList.add("is-dragging");
        };
        const move = (event)=>{
            if (!pointers.has(event.pointerId) || !this.view || !last) return;
            pointers.set(event.pointerId, {
                x: event.clientX,
                y: event.clientY
            });
            const now = gather();
            const rect = svg.getBoundingClientRect();
            const perPx = Math.max(this.view.width / rect.width, this.view.height / rect.height);
            const sideways = event.pointerType === "touch" && pointers.size === 1;
            let { x: x, y: y, width: width } = this.view;
            x -= (now.x - last.x) * perPx;
            if (!sideways) y -= (now.y - last.y) * perPx;
            if (pointers.size > 1 && last.spread > 0 && now.spread > 0) {
                // Zoom about the point between the fingers.
                const k = last.spread / now.spread;
                const ux = x + (now.x - rect.left) * perPx;
                const uy = y + (now.y - rect.top) * perPx;
                width *= k;
                x = ux - (ux - x) * k;
                y = uy - (uy - y) * k;
            }
            this.view = this.clampView({
                x: x,
                y: y,
                width: width,
                height: width / this.viewAspect
            });
            this.renderer?.setCamera(this.view, 0);
            this.updateMarkers();
            last = now;
        };
        const up = (event)=>{
            pointers.delete(event.pointerId);
            last = gather();
            if (pointers.size === 0) svg.classList.remove("is-dragging");
        };
        svg.addEventListener("pointerdown", down);
        svg.addEventListener("pointermove", move);
        svg.addEventListener("pointerup", up);
        svg.addEventListener("pointercancel", up);
        this.cleanups.push(()=>{
            svg.removeEventListener("pointerdown", down);
            svg.removeEventListener("pointermove", move);
            svg.removeEventListener("pointerup", up);
            svg.removeEventListener("pointercancel", up);
        });
    }
    /** Keeps a dragged view on the diagram and within sensible zoom. */ clampView(view) {
        const layout = this.ready[this.shown];
        const full = (layout && (0, $5ce5dd87886cfa4a$export$5f43ccd13ed5b102)(layout)) ?? {
            x: 0,
            y: 0,
            width: (0, $5ce5dd87886cfa4a$export$4923170e743afeed),
            height: (0, $5ce5dd87886cfa4a$export$4923170e743afeed)
        };
        const widest = Math.max(full.width, full.height * this.viewAspect) / $4fbea733151196ee$var$CONTENT_FILL;
        const width = $4fbea733151196ee$var$clamp(view.width, (0, $5ce5dd87886cfa4a$export$4923170e743afeed) * $4fbea733151196ee$var$PORTRAIT_MIN_SHARE, Math.max(widest, (0, $5ce5dd87886cfa4a$export$4923170e743afeed) * $4fbea733151196ee$var$MIN_VIEW_SHARE));
        const height = width / this.viewAspect;
        const cx = $4fbea733151196ee$var$clamp(view.x + view.width / 2, full.x, full.x + full.width);
        const cy = $4fbea733151196ee$var$clamp(view.y + view.height / 2, full.y, full.y + full.height);
        return {
            x: cx - width / 2,
            y: cy - height / 2,
            width: width,
            height: height
        };
    }
    /** Lit cards of the shown step, split by the side of the frame they are off. */ offFrame() {
        const off = new Map();
        const layout = this.ready[this.shown];
        const view = this.view;
        if (!layout || !view || this.shown < 0) return off;
        const step = this.steps[this.shown];
        // A wide stage always frames everything the step lights, so only a phone needs markers.
        const narrow = this.stageWidthPx > 0 && this.stageWidthPx < $4fbea733151196ee$var$NARROW_STAGE_PX;
        if (step.focus.all || !narrow) return off;
        const inner = {
            x0: view.x + view.width * $4fbea733151196ee$var$EDGE_FADE,
            x1: view.x + view.width * (1 - $4fbea733151196ee$var$EDGE_FADE),
            y0: view.y + view.height * $4fbea733151196ee$var$EDGE_FADE,
            y1: view.y + view.height * (1 - $4fbea733151196ee$var$EDGE_FADE)
        };
        const add = (side, node)=>{
            const box = {
                x: node.x - node.width / 2,
                y: node.y - node.height / 2,
                width: node.width,
                height: node.height
            };
            const seen = off.get(side);
            if (!seen) {
                off.set(side, box);
                return;
            }
            const x0 = Math.min(seen.x, box.x);
            const y0 = Math.min(seen.y, box.y);
            off.set(side, {
                x: x0,
                y: y0,
                width: Math.max(seen.x + seen.width, box.x + box.width) - x0,
                height: Math.max(seen.y + seen.height, box.y + box.height) - y0
            });
        };
        for (const node of layout.nodes){
            if (!step.focus.nodes.has(node.id)) continue;
            if (node.x + node.width / 2 > inner.x1) add("right", node);
            else if (node.x - node.width / 2 < inner.x0) add("left", node);
            if (node.y + node.height / 2 > inner.y1) add("down", node);
            else if (node.y - node.height / 2 < inner.y0) add("up", node);
        }
        return off;
    }
    updateMarkers() {
        const off = this.offFrame();
        for (const [side, marker] of this.markers)marker.classList.toggle("is-visible", off.has(side));
    }
    /** Pans just far enough, along one axis, to bring that side's lit cards into frame. */ panToward(side) {
        const target = this.offFrame().get(side);
        const view = this.view;
        if (!target || !view) return;
        const pad = view.width * $4fbea733151196ee$var$EDGE_FADE * 1.5;
        const next = {
            ...view
        };
        if (side === "right") next.x = target.x + target.width + pad - view.width;
        if (side === "left") next.x = target.x - pad;
        if (side === "down") next.y = target.y + target.height + pad - view.height;
        if (side === "up") next.y = target.y - pad;
        this.showView(this.clampView(next), this.reduceMotion ? 0 : $4fbea733151196ee$var$MARKER_PAN_MS);
    }
    buildDom() {
        const { container: container } = this;
        container.replaceChildren();
        container.classList.add($4fbea733151196ee$export$2e2bcd8739ae039.selectors.root, `is-trigger-${this.trigger}`, "is-ready");
        container.style.setProperty("--gs-steps", String(this.steps.length));
        container.style.setProperty("--gs-step-height", `${$4fbea733151196ee$var$SCROLL_STEP_HEIGHT_VH}vh`);
        this.figure = $4fbea733151196ee$var$el("figure", "graph-story__figure");
        const stage = $4fbea733151196ee$var$el("div", "graph-story__stage");
        // A framed screen so the diagram reads as a window over the page's
        // animated background rather than floating on top of it.
        const screen = $4fbea733151196ee$var$el("div", "graph-story__screen");
        const chrome = $4fbea733151196ee$var$el("div", "graph-story__chrome");
        this.chromeTitle = $4fbea733151196ee$var$el("span", "graph-story__chrome-title");
        chrome.append(this.chromeTitle);
        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("class", "graph-story__svg");
        svg.setAttribute("role", "img");
        screen.append(chrome, svg);
        const glyphs = {
            left: "<",
            right: ">",
            up: "^",
            down: "v"
        };
        for (const side of Object.keys(glyphs)){
            const marker = $4fbea733151196ee$var$button(`graph-story__marker graph-story__marker--${side}`, "Show lit cards out of frame", glyphs[side]);
            marker.addEventListener("click", ()=>this.panToward(side));
            this.markers.set(side, marker);
            screen.append(marker);
        }
        stage.append(screen);
        this.figure.append(stage);
        container.append(this.figure);
        // The camera fits each step to the stage's real aspect (portrait on
        // phones); the layout itself does not depend on the window.
        this.svg = svg;
        this.measureStage(svg);
        this.layout = new (0, $5ce5dd87886cfa4a$export$2e2bcd8739ae039)(this.steps.map((step)=>step.state), (0, $d6891e08b5dc252b$export$2d6e8db79a5f55f)());
        this.renderer = new (0, $ef5ea0a323b94b0c$export$2e2bcd8739ae039)(svg, (0, $5ce5dd87886cfa4a$export$4923170e743afeed), Math.round((0, $5ce5dd87886cfa4a$export$4923170e743afeed) / this.viewAspect));
        const figcaption = $4fbea733151196ee$var$el("figcaption", "graph-story__caption");
        this.figcaption = figcaption;
        this.title = $4fbea733151196ee$var$el("div", "graph-story__title");
        this.caption = $4fbea733151196ee$var$el("div", "graph-story__text");
        // Kicker and note are shown where the caption stands in for the scroll
        // panels (scroll mode on a phone); elsewhere the stylesheet hides them.
        this.kicker = $4fbea733151196ee$var$el("div", "graph-story__caption-kicker");
        this.note = $4fbea733151196ee$var$el("div", "graph-story__caption-note");
        figcaption.append(this.kicker, this.title, this.caption, this.note);
        const nav = $4fbea733151196ee$var$el("div", "graph-story__nav");
        this.prevButton = $4fbea733151196ee$var$button("graph-story__button graph-story__button--prev", "Previous step", "<");
        this.nextButton = $4fbea733151196ee$var$button("graph-story__button graph-story__button--next", "Next step", ">");
        const dots = $4fbea733151196ee$var$el("div", "graph-story__dots");
        this.dotStrip = dots;
        this.dots = this.steps.map((step, i)=>{
            const dot = $4fbea733151196ee$var$button("graph-story__dot", `Step ${i + 1}${step.title ? `: ${step.title}` : ""}`, "");
            dots.append(dot);
            return dot;
        });
        this.counter = $4fbea733151196ee$var$el("span", "graph-story__counter");
        nav.append(this.prevButton, dots, this.counter, this.nextButton);
        if (this.trigger === "timeline") {
            this.playButton = $4fbea733151196ee$var$button("graph-story__button graph-story__button--play", "Play", "");
            nav.append(this.playButton);
        }
        // The stepper is the screen's status bar, the counterpart of its title bar.
        screen.append(nav);
        this.figure.append(figcaption);
        if (this.trigger === "scroll") {
            // Full-screen scrollytelling: one explanation panel per step scrolls
            // past the pinned figure and drives the step index.
            const panels = $4fbea733151196ee$var$el("div", "graph-story__panels");
            this.panels = this.steps.map((step, i)=>{
                const panel = $4fbea733151196ee$var$el("article", "graph-story__panel");
                panel.dataset.step = String(i);
                const card = $4fbea733151196ee$var$el("div", "graph-story__card");
                const kicker = $4fbea733151196ee$var$el("div", "graph-story__kicker");
                kicker.textContent = `${i + 1} / ${this.steps.length}`;
                const heading = $4fbea733151196ee$var$el("h3", "graph-story__panel-title");
                heading.textContent = step.title;
                const caption = $4fbea733151196ee$var$el("p", "graph-story__panel-caption");
                caption.innerHTML = step.caption;
                card.append(kicker, heading, caption);
                if (step.body) {
                    const body = $4fbea733151196ee$var$el("div", "graph-story__panel-body");
                    body.innerHTML = step.body;
                    card.append(body);
                }
                panel.append(card);
                panels.append(panel);
                return panel;
            });
            container.append(panels);
        }
        container.tabIndex = 0;
    }
    bindControls() {
        this.prevButton.addEventListener("click", ()=>{
            this.pause();
            this.prev();
        });
        this.nextButton.addEventListener("click", ()=>{
            this.pause();
            this.next();
        });
        this.dots.forEach((dot, i)=>dot.addEventListener("click", ()=>{
                this.pause();
                this.goTo(i);
            }));
        this.playButton?.addEventListener("click", ()=>this.playing ? this.pause() : this.play());
        const onKey = (event)=>{
            if (event.key === "ArrowRight") {
                this.pause();
                this.next();
                event.preventDefault();
            } else if (event.key === "ArrowLeft") {
                this.pause();
                this.prev();
                event.preventDefault();
            }
        };
        this.container.addEventListener("keydown", onKey);
        this.cleanups.push(()=>this.container.removeEventListener("keydown", onKey));
    }
    bindScroll() {
        const update = ()=>{
            this.scrollFrame = null;
            const step = this.stepFromScroll();
            if (step === this.pendingIndex) this.pendingIndex = null;
            this.applyStep(step, this.index === -1);
        };
        const schedule = ()=>{
            if (this.scrollFrame === null) this.scrollFrame = window.requestAnimationFrame(update);
        };
        window.addEventListener("scroll", schedule, {
            passive: true
        });
        this.cleanups.push(()=>window.removeEventListener("scroll", schedule));
        update();
    }
    /**
   * The active step is the last panel whose top has crossed the middle of the
   * viewport. Panel tops are cached: measuring all of them on every scroll
   * frame forces a layout flush per frame, which is the page's worst jank.
   */ stepFromScroll() {
        if (this.panelTops.length !== this.panels.length) this.measurePanels();
        const middle = window.scrollY + window.innerHeight / 2;
        let index = 0;
        for(let i = 0; i < this.panelTops.length; i++)if (this.panelTops[i] <= middle) index = i;
        return index;
    }
    measurePanels() {
        this.panelTops = this.panels.map((panel)=>panel.getBoundingClientRect().top + window.scrollY);
    }
    scrollToStep(index) {
        if (this.panelTops.length !== this.panels.length) this.measurePanels();
        const top = this.panelTops[index];
        if (top === undefined) return;
        const target = top - window.innerHeight * 0.25;
        window.scrollTo({
            top: target,
            behavior: this.reduceMotion ? "auto" : "smooth"
        });
    }
    bindAutoplay() {
        if (this.reduceMotion) return;
        const observer = new IntersectionObserver((entries)=>{
            for (const entry of entries)if (entry.isIntersecting) this.play();
            else this.pause();
        }, {
            threshold: 0.5
        });
        observer.observe(this.figure);
        this.cleanups.push(()=>observer.disconnect());
    }
    tickAutoplay() {
        if (!this.playing) return;
        this.timer = window.setTimeout(()=>{
            if (this.index >= this.steps.length - 1) this.applyStep(0, false);
            else this.next();
            this.tickAutoplay();
        }, this.spec.interval ?? $4fbea733151196ee$var$DEFAULT_INTERVAL);
    }
    updateChrome() {
        const step = this.steps[this.index];
        this.title.textContent = step.title;
        this.caption.innerHTML = step.caption;
        this.kicker.textContent = `${this.index + 1} / ${this.steps.length}`;
        this.note.innerHTML = step.body;
        // A new step's text starts at its beginning, wherever the last one was scrolled to.
        this.figcaption.scrollTop = 0;
        const width = String(this.steps.length).length;
        this.counter.textContent = `${String(this.index + 1).padStart(width, "0")}/${this.steps.length}`;
        this.chromeTitle.textContent = step.title;
        this.prevButton.disabled = this.index === 0;
        this.nextButton.disabled = this.index === this.steps.length - 1;
        this.dots.forEach((dot, i)=>{
            dot.classList.toggle("is-active", i === this.index);
            dot.classList.toggle("is-done", i < this.index);
            dot.setAttribute("aria-current", i === this.index ? "step" : "false");
        });
        this.panels.forEach((panel, i)=>panel.classList.toggle("is-active", i === this.index));
        this.revealActiveDot();
    }
    /**
   * The step strip scrolls sideways rather than shrinking its blocks to fit,
   * so keep the current step in the middle of it. Only the strip scrolls:
   * scrollIntoView would also move the page, which drives scroll mode.
   */ revealActiveDot() {
        const strip = this.dotStrip;
        const dot = this.dots[this.index];
        if (!dot || strip.scrollWidth <= strip.clientWidth) return;
        const left = dot.offsetLeft - (strip.clientWidth - dot.offsetWidth) / 2;
        strip.scrollTo({
            left: left,
            behavior: this.reduceMotion ? "auto" : "smooth"
        });
    }
}
function $4fbea733151196ee$var$el(tag, className) {
    const node = document.createElement(tag);
    node.className = className;
    return node;
}
function $4fbea733151196ee$var$button(className, label, text) {
    const node = document.createElement("button");
    node.type = "button";
    node.className = className;
    node.setAttribute("aria-label", label);
    node.title = label;
    node.textContent = text;
    return node;
}
function $4fbea733151196ee$var$clamp(value, min, max) {
    return min > max ? (min + max) / 2 : Math.min(max, Math.max(min, value));
}







const $495dcced4616a089$var$TRIGGERS = new Set([
    "scroll",
    "click",
    "timeline"
]);
function $495dcced4616a089$var$readSpec(container) {
    const script = container.querySelector("script[data-graph-story]");
    if (!script?.textContent) return null;
    const parsed = JSON.parse(script.textContent);
    if (!parsed || typeof parsed !== "object" || !Array.isArray(parsed.steps)) throw new Error(`[graph-story] "${container.dataset.graph}" is not a story spec`);
    return parsed;
}
function $495dcced4616a089$var$mount(container) {
    const spec = $495dcced4616a089$var$readSpec(container);
    if (!spec) return;
    const trigger = container.dataset.trigger;
    new (0, $4fbea733151196ee$export$2e2bcd8739ae039)(container, spec, {
        trigger: trigger && $495dcced4616a089$var$TRIGGERS.has(trigger) ? trigger : undefined
    }).init();
}
async function $495dcced4616a089$var$boot() {
    // Cards are sized from measured text, so the pixel font has to be loaded
    // before the first layout or every card comes out the wrong width.
    try {
        await document.fonts?.ready;
    } catch  {
    // Font loading is a progressive enhancement; fall back to whatever is ready.
    }
    document.querySelectorAll(".graph-story[data-graph]").forEach($495dcced4616a089$var$mount);
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ()=>void $495dcced4616a089$var$boot(), {
    once: true
});
else $495dcced4616a089$var$boot();


//# sourceMappingURL=index.cd539a39.js.map
